import countryLocales from 'i18n-iso-countries/langs/fr.json';
import countries      from 'i18n-iso-countries';

countries.registerLocale(countryLocales);

export const AllCountries: Record<CountryCode, string> = countries.getNames('fr', { select: 'official' }) as Record<CountryCode, string>;

export const getCountryName = (code: CountryCode) => countries.getName(code, 'fr', { select: 'official' });